;(() => {
    const menus = document.querySelectorAll('.js-click-menu')
    const openedClass = 'js-click-menu_opened'

    window.addEventListener('click', e => {
        menus.forEach(menu => {
            if (CNS.isSameOrChild(menu, e.target)) { return }
            menu.classList.remove(openedClass)
        })
    })

    menus.forEach(menu => {
        // menu.querySelectorAll('.js-click-menu__link').forEach(link => {
        //     link.addEventListener('click', e => e.stopPropagation())
        // })

        menu.addEventListener('click', e => {
            menu.classList.toggle(openedClass)
        })
    })
})();